
const cadenas = {
    stringToSlug(texto) {
        const result = texto
            .toString()
            .normalize('NFD')
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '_')
            .replace(/[^\w\-]+/g, '')    
        return result    
    },
}

export default cadenas